export default __webpack_public_path__ + "static/media/T44.66104547.JPG";